// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Y3MK","inner":"Form_inner__RwgPn","range":"Form_range__2mEKd","name":"Form_name__1Hfzm","actions":"Form_actions__3R10V"};